module.exports = __webpack_public_path__ + "static/img/header.367a6c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header.png
// module id = C/5X
// module chunks = 3